import React from 'react';

import SvgIcon from '../../Icons';

import './index.sass';


const FormicCheckbox = ({ id, error, handleChange, handleBlur, label, value }) => {

  return (
    <div className={`checkbox ${error ? 'error' : ''}`}>
      <div className="checkbox__wrapper">
        <label className="checkbox__label" htmlFor={id}>
          <input
            name={id}
            type="checkbox"
            checked={value}
            id={id}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          <span className="checkmark">
          <SvgIcon name="check" size={17} />
        </span>
          <div className="checkbox__label-text">
            { label }
          </div>
        </label>
      </div>
      { error &&
        <div className="checkbox__error-tooltip">
          { error }
        </div>
      }
    </div>
  )
}

export default FormicCheckbox;
